
import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';

@Component({
  name: 'loading-spinner',
  components: {},
})
export default class LoadingSpinner extends Vue {}
